export default __webpack_public_path__ + "static/media/BROOBEE-CAKE.4738a050.svg";